import React from "react";
import Classes from "./styles/style.module.css";
import HintIcon from "../../../assets/images/icons/informationIcon.svg";

const CustomHint = ({ hint, children }) => {
  return (
    <div className={Classes.hintContainer}>
      <img src={HintIcon} alt="hintIcon" />
      {children !== undefined ? (
        <p>{children}</p>
      ) : (
        <p dangerouslySetInnerHTML={{__html:hint}}></p>
      )}
    </div>
  );
};

export default CustomHint;
